<template>
  <div>
    <div v-show="documents.length === 0">
      <base-alert type="warning" class="mb-4 info-min">
        <i class="flaticon-warning mr-1"></i> There are no documents here
      </base-alert>
    </div>
    <div
      v-show="documents.length > 0"
      v-for="(item, index) in documentsOptions.slice(
        0,
        searchCriteria.pagination.limit
      )"
      :key="index"
    >
      <router-link :to="getPathToArticle(item)" class="box-card-documents">
        <div
          class="card-documents card-h"
          :class="{ 'card-lg-h': size == 'lg' }"
        >
          <div class="row">
            <div
              class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12 align-self-center pr-0"
            >
              <div class="header-box">
                <div class="carousel-box">
                  <div class="container-img">
                    <div class="img-box">
                      <img v-lazy="item.image" :alt="`${item.title}`" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-xl-9 col-lg-9 col-md-8 col-sm-8 col-12 align-self-center"
            >
              <div class="content-card">
                <h4 class="card-title">
                  {{ item.title }}
                </h4>

                <div class="excerpt" v-if="excerpt">
                  <p>
                    {{ item.short_description }}
                  </p>
                </div>

                <div class="footer-product" v-if="item.module">
                  <router-link
                    :to="`/help/${item.module}`"
                    class="type"
                    v-if="size == 'lg'"
                  >
                    {{ item.module }}
                  </router-link>
                </div>
                <div class="footer-product" v-else>
                  <router-link
                    :to="`/help/releases`"
                    class="type"
                    v-if="size == 'lg'"
                  >
                    Releases
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>
<script>
import { DocumentsAPI } from "../../../../../core/api";
import lodash from "lodash";
export default {
  name: "CardArticles",
  props: {
    classes: {
      type: String,
      default: "",
      description: "class card"
    },
    size: {
      type: String,
      required: false,
      default: "",
      description: "lg-md-sm-smcolum"
    },
    excerpt: {
      type: Boolean,
      required: false,
      default: false,
      description: "Show excerpt"
    },
    searchCriteria: {
      type: Object,
      required: false,
      description: "Search criteria"
    }
  },

  data() {
    return {
      documents: []
    };
  },
  watch: {
    searchCriteria: {
      handler: async function(current, old) {
        if (!lodash.isEqual(current, old)) {
          this.documents = await this.getDocumentsBySearchCriteria(current);
        }
      },
      deep: true
    }
  },
  async created() {
    this.documents = await this.getDocumentsBySearchCriteria(
      this.searchCriteria
    );
  },
  methods: {
    async getDocumentsBySearchCriteria(searchCriteria) {
      try {
        let { data } = await DocumentsAPI.getDocumentsBySearchCriteria(
          searchCriteria
        );
        if (data.status) {
          return data.data.docs;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    getPathToArticle(document) {
      if (document.type === "RELEASE") {
        return `/help/release/${document.slug}`;
      } else {
        return `/help/${this.getSlugModule(document.module)}/${document.slug}`;
      }
    },
    getSlugModule(module) {
      if (module === "ACCOUNT") {
        return "account";
      } else if (module === "DRIVER") {
        return "driver";
      } else if (module === "AREAS") {
        return "areas";
      } else if (module === "PARTNERS") {
        return "partners";
      } else if (module === "CUSTOMERS") {
        return "customers";
      } else if (module === "DESTINATIONS") {
        return "destinations";
      } else if (module === "DOCUMENTATION") {
        return "documentation";
      } else if (module === "EXPERIENCES") {
        return "experiences";
      } else if (module === "GLOBAL") {
        return "global";
      } else if (module === "LOGS") {
        return "logs";
      } else if (module === "PROFILE") {
        return "profile";
      } else if (module === "RATES") {
        return "rates";
      } else if (module === "RESERVATIONS") {
        return "reservations";
      } else if (module === "SUPPLIERS") {
        return "suppliers";
      } else if (module === "TEAM") {
        return "team";
      } else if (module === "VEHICLES") {
        return "vehicles";
      } else if (module === "VEHICLES_GALLERY") {
        return "vehicles-gallery";
      } else if (module === "DASHBOARD") {
        return "dashboard";
      }
    }
  },
  computed: {
    documentsOptions: function() {
      return this.documents.map(document => {
        return {
          title: document.title,
          type: document.type,
          app: document.app,
          module: document.module,
          image:
            document.images.length > 0
              ? document.images[0]
              : "https://upcdn.io/FW25b8h/raw/documents/covers/rhomtrip-img-doc.png",
          short_description: document.short_description,
          slug: document.slug
        };
      });
    }
  }
};
</script>
